import type { SwapQuote } from '@/lib/swap';

/** Quote timestamps are provider supplied and may be Unix seconds or milliseconds. */
export function quoteExpiryMs(expiresAt: number | undefined): number | null {
  if (!Number.isFinite(expiresAt) || !expiresAt || expiresAt <= 0) return null;
  return expiresAt < 10_000_000_000 ? expiresAt * 1000 : expiresAt;
}

export function quoteSecondsRemaining(
  quote: Pick<SwapQuote, 'expiresAt'> | null | undefined,
  now: number,
): number | null {
  const expiry = quoteExpiryMs(quote?.expiresAt);
  return expiry === null ? null : Math.max(0, Math.ceil((expiry - now) / 1000));
}

export function isQuoteExpired(
  quote: Pick<SwapQuote, 'expiresAt'> | null | undefined,
  now: number,
): boolean {
  return quoteSecondsRemaining(quote, now) === 0;
}

export type PriceImpactTone = 'neutral' | 'warning' | 'danger';

export type SwapAmountIssue = 'zero' | 'precision' | 'invalid';

/** Classify an invalid amount into copy a person can act on. */
export function swapAmountIssue(value: string, decimals: number): SwapAmountIssue {
  const trimmed = value.trim();
  if (/^(?:0+(?:\.0*)?|\.0*)$/.test(trimmed)) return 'zero';
  const decimal = /^\d*\.(\d+)$/.exec(trimmed);
  if (decimal && decimal[1].length > decimals) return 'precision';
  return 'invalid';
}

export function priceImpactTone(value: string | undefined): PriceImpactTone {
  const impact = Number(value);
  if (!Number.isFinite(impact)) return 'neutral';
  if (impact >= 5) return 'danger';
  if (impact >= 1) return 'warning';
  return 'neutral';
}
